import { useNavigate } from "react-router-dom"
import { useSetRecoilState } from "recoil"
import styled from "styled-components"
import { isMenuExpandedState } from "../../../recoil/common/Header"

const LogoButton = () => {
  const navigate = useNavigate()
  const setIsMenuExpanded = useSetRecoilState(isMenuExpandedState)

  return (
    <LogoContainer>
      <Logo
        onClick={() => navigate("/")}
        onMouseEnter={() => setIsMenuExpanded(false)}
      >
        LOGO
      </Logo>
    </LogoContainer>
  )
}

export default LogoButton

const LogoContainer = styled.div`
  width: 80px;

  @media ${({ theme }) => theme.device.pc} {
    text-align: start;
    width: 200px;
  }
`

const Logo = styled.div`
  cursor: pointer;
  color: var(--custom-deep-dark-brown);
  font-size: 20px;
  line-height: 100%;
  font-weight: bold;
`
